import { ApiService } from "../../../services/ApiService";
import {
  GET_ALL_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS,
  GET_READ_NOTIFICATION,
} from "../../actionTypes";

export class notificationsThunk {
  static getNextNotifications(query) {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(`notifications/get-all${query}`);
        if (response.data) {
          dispatch({
            type: GET_ALL_NOTIFICATIONS,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getAllNotifications() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("notifications/get-all");
        if (response.data) {
          dispatch({
            type: GET_ALL_NOTIFICATIONS,
            payload: response.data.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getUnreadNotifications() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("notifications/get-unread");
        if (response.data) {
          dispatch({
            type: GET_UNREAD_NOTIFICATIONS,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  // static getReadNotifications(id) {
  //   console.log("IDDD", id)
  //   return async (dispatch) => {
  //     try {
  //       const response = await ApiService.post(`notifications/mark-as-read/${id}`);
  //       console.log("RESPONSE", response)
  //       if (response.data) {
  //         dispatch({
  //           type: GET_READ_NOTIFICATION,
  //           payload: response.data,
  //         });
  //         return;
  //       }
  //     } catch (err) {}
  //   };
  // }
}



// WEBPACK FOOTER //
// ./src/store/actions/notifications/notification.thunk.js